import { render, staticRenderFns } from "./CaseView.vue?vue&type=template&id=cf370c92&scoped=true"
import script from "./CaseView.vue?vue&type=script&lang=js"
export * from "./CaseView.vue?vue&type=script&lang=js"
import style0 from "./CaseView.vue?vue&type=style&index=0&id=cf370c92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf370c92",
  null
  
)

export default component.exports